/* eslint-disable eqeqeq */
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dimond from '../assets/images/greyled-activity.svg';
import moment from 'moment';
import MediaComponent from '../components/createmode/MediaComponent';
const currentMonth = moment().month();
const daysInMonth = moment().daysInMonth();
const datesArray = [];
for (let day = 1; day <= daysInMonth; day++) {
  const date = moment().month(currentMonth).date(day);
  datesArray.push(date.date());
}

const BookParagraph = ({ bookId, chapters, activity, setTabs, scrollId, setScrollId, mode }) => {
  // const { settings } = useSelector((state) => state.settings);
  const { loaders } = useSelector((state) => state.ui);
  const { settings } = useSelector((state) => state.settings.settings);
  const [activities, setActivities] = useState([]);
  const [scrollToId, setScrollToId] = useState(null);
  const [highlightedSection, setHighlightedSection] = useState(null);
  const [setMousePosition] = useState({ x: 0, y: 0 });
  const [dragging] = useState(false);
  const [creatingActivity] = useState(undefined);
  const [draggedOver] = useState(null);
  const [reverse] = useState(false);
  const [highlightedIndexes] = useState([]);
  const [isResizing, setIsResizing] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const [highlightedParagraph, setHighlightedParagraph] = useState(null);
  const [isDraggingActivity, setIsDraggingActivity] = useState(false);

  const [, setDraggedActivityPosition] = useState({
    top: 0,
    left: 0,
  });

  useEffect(() => {
    if (scrollId) {
      const div = document.getElementById(scrollId);
      if (div) {
        setTabs('book');
        setTimeout(() => {
          div.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 300);
        setScrollId('');
      }
    }
  }, [scrollId, setTabs, setScrollId]);

  const scrollerRef = useRef(null);

  useEffect(() => {
    if (scrollToId) {
      const div = document.getElementById(scrollToId);
      if (div) {
        div.scrollIntoView({ block: 'start' });
        setScrollToId(null);
      }
    }
  }, [scrollToId]);
  useEffect(() => {
    if (activity) {
      let id = '';
      id += activity.chapter;
      id += activity.sections && activity.sections.length > 0 && '.' + activity.sections[0];
      id += activity.paragraphs?.length > 0 ? '.' + activity.paragraphs[0] : '';

      const div = document.getElementById(id);
      if (div) {
        div.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [activity, chapters]);

  const scrollableContent = (scroller) => {
    scrollerRef.current = scroller;
  };

  const highlightSection = (e, value) => {
    if (creatingActivity) return;
    if (highlightedSection === value) {
      setHighlightedSection(null);
      setActivities(activities);
    } else {
      setHighlightedSection(value);
      setActivities(activities.filter((e) => e.section === value.split('.')[1] && e.paragraphs.length === 0));
      // setScrollToId(value);
    }
  };

  const dynamicPStyles = (chap, section, paragraph) => {
    let className = 'mt-3 theme_para_se paragraph_element main_p';

    className += activities.findIndex((e) => e.paragraphs.includes(paragraph._id)) > -1 ? ' rich' : '';
    className += settings.fontLarge ? ' fontLarge' : '';
    className += highlightedIndexes.includes(`${chap._id}.${section._id}.${paragraph._id}`) ? ' activated_p_tags' : '';
    className += highlightedParagraph === paragraph._id ? ' bg_grey' : '';

    return className;
  };

  const dynamicSectionStyles = (chap, section) => {
    let className = 'section_element ';

    // Check if settings and settings.fontLarge are defined
    className += settings?.fontLarge ? ' fontLarge' : '';

    // Check if highlightedSection is defined and matches the current section
    className += highlightedSection === `${chap._id}.${section._id}` ? ' highlighted' : '';

    // Check if draggedOver is defined and matches the current section
    className += draggedOver && draggedOver.type === 'section' && draggedOver.index == `${chap._id}.${section._id}` ? ' trigger' : '';
    className += activity?.sections && activity?.sections?.length > 0 && activity?.paragraphs.length === 0 && activity?.sections?.includes(section._id) && !loaders.bookLoader ? ' student_highlighted_section' : ' mb-2';

    return className;
  };

  return (
    <div>
      <section className='class_room_wrap teach mt-0'>
        <div>
          <div
            className={`flex-container`}
            onMouseMove={(event) => {
              event.preventDefault();
              if (isDraggingActivity) {
                setDraggedActivityPosition({
                  top: (event.clientY / window.innerHeight) * 100,
                  left: (event.clientX / window.innerWidth) * 100,
                });
              }
              if (!dragging) return;
              const left = (event.clientX / window.innerWidth) * 100; // percentage of viewport width
              const top = (event.clientY / window.innerHeight) * 100; // percentage of viewport height
              setMousePosition({ x: left, y: top });
              if (isScrolling) {
                const { clientY: y } = event;
                const { scrollTop } = scrollerRef.current;
                scrollerRef.current.scrollTop = scrollTop + y;
              }
            }}
            onMouseUp={(e) => {
              if (isResizing) setIsResizing(false);
              if (isScrolling) setIsScrolling(false);
              if (isDraggingActivity) {
                setIsDraggingActivity(false);
              }
              e.stopPropagation();
            }}
          >
            <div className={`row ${reverse ? 'reverse' : ''}`} style={{ width: '100%', paddingRight: ' 0px' }}>
              <div className='center_content' ref={scrollableContent} style={{ paddingTop: '0px' }}>
                <Fragment>
                  {chapters.map((chap, chapInd) => (
                    <div className={`book chapter_element chap-sec-par ${!activity?.sections || (activity?.sections?.length === 0 && activity?.chapter === chap._id && !loaders?.bookLoader) ? 'student_highlighted_section ' : ''}`} data-id={chapInd} key={chapInd} id={chap?._id}>
                      {loaders.bookLoader ? (
                        <>
                          <div className='chap-load'>
                            <div
                              className='content-skeleton mb-0 inner-head-load'
                              style={{
                                height: '58px',
                                width: '64%',
                                borderRadius: '4px',
                              }}
                            ></div>
                            <div
                              className='content-skeleton mb-0 inner-head-load'
                              style={{
                                height: '29px',
                                width: '100%',
                                borderRadius: '4px',
                              }}
                            ></div>
                          </div>
                        </>
                      ) : (
                        !loaders?.bookLoader && (
                          <>
                            <div
                              className={`sub_heading max_550 chapter_element ${draggedOver && draggedOver.type === 'chapter' && draggedOver.index === chap._id ? 'trigger' : ''}`}
                              data-id={chap._id}
                              dangerouslySetInnerHTML={{
                                __html: chap.title,
                              }}
                            ></div>
                            <p
                              className={settings?.fontLarge ? 'theme_para_se chapter_element fontLarge' : 'theme_para_se chapter_element fontLarge'}
                              data-id={chap?._id}
                              dangerouslySetInnerHTML={{
                                __html: chap.description,
                              }}
                            ></p>
                            <hr className='activity-line ' />
                          </>
                        )
                      )}
                      {chap.sections.map((section, secIndex) => (
                        <div key={secIndex} id={`${chap._id}.${section._id}`} data-id={`${chap._id}.${section._id}`} className={dynamicSectionStyles(chap, section)} style={{ position: 'relative', paddingTop: '12px' }}>
                          {loaders?.bookLoader ? (
                            <>
                              <div className='' style={{ marginTop: '32px' }}>
                                <div
                                  className='content-skeleton  inner-head-load'
                                  style={{
                                    height: '38px',
                                    width: '38%',
                                    borderRadius: '4px',
                                    marginBottom: '4px',
                                  }}
                                ></div>
                                <div
                                  className='content-skeleton  inner-head-load'
                                  style={{
                                    height: '116px',
                                    width: '100%',
                                    borderRadius: '4px',
                                    marginBottom: '32px',
                                  }}
                                ></div>
                                <div
                                  className='content-skeleton  inner-head-load'
                                  style={{
                                    height: '319px',
                                    width: '100%',
                                    borderRadius: '4px',
                                    marginBottom: '20px',
                                  }}
                                ></div>
                                <div
                                  className='content-skeleton  inner-head-load'
                                  style={{
                                    height: '290px',
                                    width: '100%',
                                    borderRadius: '4px',
                                  }}
                                ></div>
                              </div>
                            </>
                          ) : (
                            !loaders?.bookLoader && (
                              <>
                                {activities.findIndex((e) => e.section === section._id) > -1 ? (
                                  <img
                                    src={dimond}
                                    alt='diamond'
                                    className='cursor'
                                    onClick={(e) => {
                                      setHighlightedParagraph(null);
                                      highlightSection(e, `${chap._id}.${section._id}`);
                                    }}
                                    style={{
                                      // position: "absolute",
                                      // top: -12,
                                      // right: 4,
                                      position: 'relative',
                                      float: 'right',
                                    }}
                                  />
                                ) : (
                                  ''
                                )}
                                <h5
                                  className={` mb-0 ${activities.findIndex((e) => e.section === section._id) > -1 ? 'rich' : ''}`}
                                  dangerouslySetInnerHTML={{
                                    __html: section.title,
                                  }}
                                ></h5>
                                {section.paragraphs.map((paragraph, index) => (
                                  <>
                                    {(paragraph?.text || (paragraph?.type === 'paragraph' && paragraph?.media.length > 0)) && (
                                      <div
                                        key={index}
                                        // key={paragraph._id}
                                        className={`${draggedOver && draggedOver.type === 'paragraph' && draggedOver.index === `${chap._id}.${section._id}.${paragraph._id}` ? 'trigger' : ''} main-pera-wraper-std unique_paragraph ${isResizing ? 'resizing' : 'cursors'} ${activity?.paragraphs?.includes(paragraph._id) && !loaders.bookLoader ? 'student_highlighted_section' : ''}`}
                                        data-id={paragraph._id}
                                        data-secid={section._id}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          //   setCalendarShow(false);
                                        }}
                                      >
                                        {
                                          <div
                                            className='mini_heading paragraph_element'
                                            data-id={paragraph._id}
                                            dangerouslySetInnerHTML={{
                                              __html: paragraph.title,
                                            }}
                                          ></div>
                                        }
                                        <div className={dynamicPStyles(chap, section, paragraph)} data-id={`${chap._id}.${section._id}.${paragraph._id}`} key={index} id={`${chap._id}.${section._id}.${paragraph._id}`} style={{ position: 'relative' }}>
                                          {/*   {activities.findIndex((e) =>
                                        e.paragraphs.includes(paragraph._id)
                                      ) > 1 && (
                                        <img
                                          src={dimond}
                                          alt="diamond"
                                          className="cursor"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setHighlightedSection(null);
                                            if (
                                              highlightedParagraph ===
                                              paragraph._id
                                            ) {
                                              setHighlightedParagraph(null);
                                              setActivities(activities);
                                            } else {
                                              setHighlightedParagraph(
                                                paragraph._id
                                              );
                                              setActivities(
                                                activities.filter((e) =>
                                                  e.paragraphs.includes(
                                                    paragraph._id
                                                  )
                                                )
                                              );
                                            }
                                          }}
                                          style={{
                                            position: "absolute",
                                            top: -20,
                                            right: 12,
                                          }}
                                        />
                                      )} */}
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: paragraph.text,
                                            }}
                                          ></div>

                                          {paragraph.media && Array.isArray(paragraph.media) && (
                                            <Fragment>
                                              {paragraph.media.map((media, mIndex) => (
                                                <MediaComponent chapterIndex={chapInd} secInd={secIndex} pIndex={index} setBook={() => {}} book={{}} media={media} index={mIndex} parent={'paragraph'} parentId={paragraph._id} key={mIndex} />
                                              ))}
                                            </Fragment>
                                          )}

                                          {paragraph.image && paragraph.image.link ? (
                                            <div>
                                              <img src={paragraph.image.link} alt='paragraph-related' />
                                              <span>{paragraph.image.description}</span>
                                            </div>
                                          ) : (
                                            ''
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </>
                                ))}
                              </>
                            )
                          )}
                        </div>
                      ))}

                      <div className='chapter_element' data-id={chap._id} style={{ width: '100%', height: '1px' }}></div>
                    </div>
                  ))}
                </Fragment>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BookParagraph;
